"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrow_chart_line = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var arrow_chart_line = function arrow_chart_line(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'arrow-chart-line-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M17.5303 5.21967C17.8232 5.51256 17.8232 5.98744 17.5303 6.28033L11.0303 12.7803C10.7374 13.0732 10.2626 13.0732 9.96967 12.7803L8 10.8107L3.53033 15.2803C3.23744 15.5732 2.76256 15.5732 2.46967 15.2803C2.17678 14.9874 2.17678 14.5126 2.46967 14.2197L7.46967 9.21967C7.76256 8.92678 8.23744 8.92678 8.53033 9.21967L10.5 11.1893L16.4697 5.21967C16.7626 4.92678 17.2374 4.92678 17.5303 5.21967Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M12.25 5.75C12.25 5.33579 12.5858 5 13 5L17 5C17.4142 5 17.75 5.33579 17.75 5.75V9.75C17.75 10.1642 17.4142 10.5 17 10.5C16.5858 10.5 16.25 10.1642 16.25 9.75V6.5L13 6.5C12.5858 6.5 12.25 6.16421 12.25 5.75Z',
    fill: '#4B5563'
  }));
};

exports.arrow_chart_line = arrow_chart_line;